import { render } from "./AccordionSlot.vue?vue&type=template&id=19cc043f"
import script from "./AccordionSlot.vue?vue&type=script&lang=js"
export * from "./AccordionSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__